import {getInfo, login, logout,getPublicKey} from '@/api/login'
import {getToken, removeToken, setToken} from '@/utils/auth'
import JSEncrypt from 'jsencrypt'
const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    adminId:''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_ADMINID: (state, adminId) => {
      state.adminId = adminId
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
        let password = userInfo.password;
        let publicKey = userInfo.publicKey;
        const encrypt = new JSEncrypt()
        encrypt.setPublicKey(publicKey)
        password = encrypt.encrypt(password)
        return new Promise((resolve, reject) => {
          login(username, password,userInfo.yanzhengma).then(response => {
            const data = response.data
            const tokenStr = data.tokenHead+data.token
            setToken(tokenStr)
            commit('SET_TOKEN', tokenStr)
            resolve()
          }).catch(error => {
            reject(error)
          })
        })

    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          commit('SET_ADMINID', data.adminId)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js